<schedule-detail-header [title]="isShowingAssertionOnly ? 'Assertion Details' : 'Issue Details'"
                        [subtitle]="breadcrumb()"
                        [backCallback]="goBack.bind(this)"
                        [showCloud]="true">
</schedule-detail-header>

<div class="issue-detail-container"
     *ngIf="!loading"
     data-testid="issue-detail-container">
  <div class="issue-detail-content"
       *ngIf="assertion"
       data-testid="issue-detail-content">
    <div class="assertion-detail-item"
         data-testid="issue-detail-question">
      <label class="body-sm-regular text-gray-900">Punchlist Question</label>
      <p [innerHTML]="assertion.text"
         class="body-md-medium text-gray-900"
         data-testid="issue-detail-text-question"></p>
    </div>

    <div class="issue-detail-item"
         *ngIf="!isShowingAssertionOnly && issue"
         data-testid="issue-detail-notes">
      <label class="body-sm-regular text-gray-900">Notes</label>
      <p [innerHTML]="issue.text"
         class="body-md-medium text-gray-900"
         data-testid="issue-detail-text-notes"></p>
    </div>

    <!-- This is a CCM only component so we only need to check for ccmNote -->
    <div class="assertion-detail-item"
         *ngIf="isShowingAssertionOnly && assertion.ccmNote"
         data-testid="issue-detail-assertion-notes">
      <label class="body-sm-regular text-gray-900">Notes</label>
      <p class="body-md-medium text-gray-900"
         data-testid="issue-detail-text-assertion-notes">{{ assertion.ccmNote }}</p>
    </div>

    <div class="issue-detail-item"
         *ngIf="!isShowingAssertionOnly && issue"
         data-testid="issue-detail-severity">
      <span class="severity-tag"
            [class]="((issue.severity || 'minor') + '-issue') | lowercase"
            data-testid="issue-detail-badge-severity">
        {{ (issue.severity || 'Minor') | titlecase }} Issue
      </span>
    </div>

    <div class="issue-detail-item"
         *ngIf="!isShowingAssertionOnly && issueImages.length"
         data-testid="issue-detail-images">
      <app-assertion-image-gallery [images]="issueImages || []"
                                   [readonly]="true">
      </app-assertion-image-gallery>
    </div>

    <div class="assertion-detail-item"
         *ngIf="isShowingAssertionOnly && assertionImages.length"
         data-testid="issue-detail-assertion-images">
      <app-assertion-image-gallery [images]="assertionImages || []"
                                   [readonly]="true">
      </app-assertion-image-gallery>
    </div>

    <div class="assertion-detail-item"
         *ngIf="isShowingAssertionOnly && assertion.issues?.length"
         data-testid="issue-detail-issues-list">
      <label>Issues</label>
      <div class="issues-list">
        <div class="issue-item clickable-issue"
             *ngFor="let i of assertion.issues"
             (click)="viewIssue(i)"
             role="button"
             tabindex="0"
             (keyup.enter)="viewIssue(i)"
             data-testid="issue-detail-item">
          <div class="issue-header">
            <span class="issue-severity"
                  [class]="'severity-' + (i.severity || 'minor') | lowercase"
                  data-testid="issue-detail-item-badge-severity">
              {{ (i.severity || 'Minor') | titlecase }}
            </span>
            <i class="pi pi-chevron-right issue-chevron"></i>
          </div>
          <p class="issue-notes"
             data-testid="issue-detail-item-text-notes">{{ i.text }}</p>
        </div>
      </div>
    </div>

  </div>

  <div class="no-issue-message"
       *ngIf="!assertion"
       data-testid="issue-detail-container-empty">
    <i class="pi pi-exclamation-triangle"></i>
    <span>Assertion not found</span>
  </div>
</div>

<div class="loading-container"
     *ngIf="loading"
     data-testid="issue-detail-container-loading">
  <i class="pi pi-spinner pi-spin"></i>
  <span>Loading...</span>
</div>

<div class="detail-footer"
     data-testid="issue-detail-footer">
  <button class="action-button"
          (click)="goBack()"
          data-testid="issue-detail-btn-return">
    Return to list
  </button>
</div>